import { render, staticRenderFns } from "./column-data.vue?vue&type=template&id=25e0d0d1&scoped=true&"
import script from "./column-data.vue?vue&type=script&lang=js&"
export * from "./column-data.vue?vue&type=script&lang=js&"
import style0 from "./column-data.vue?vue&type=style&index=0&id=25e0d0d1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25e0d0d1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/contactum-new/contactum-new/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('25e0d0d1')) {
      api.createRecord('25e0d0d1', component.options)
    } else {
      api.reload('25e0d0d1', component.options)
    }
    module.hot.accept("./column-data.vue?vue&type=template&id=25e0d0d1&scoped=true&", function () {
      api.rerender('25e0d0d1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/admin/components/pro/field-template/column-data.vue"
export default component.exports